/**
 * Erzwingt in JEDER Installation und auf JEDER Seite das Favicon aus dem
 * hinterlegten Firmenlogo (`/api/shop/app-icon-*.png`, serverseitig aus dem
 * Logo der Installation gerendert). Entfernt dabei alte/statische Icon-Links,
 * damit kein fremdes Logo aus gecachtem HTML übrig bleibt.
 */
import { useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const ICONS = [
  { rel: 'icon', type: 'image/png', sizes: '32x32', size: 32 },
  { rel: 'icon', type: 'image/png', sizes: '16x16', size: 16 },
  { rel: 'icon', type: 'image/png', sizes: '192x192', size: 192 },
  { rel: 'shortcut icon', type: 'image/png', sizes: '', size: 32 },
  { rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', size: 180 },
];

function applyIcons(version) {
  document.querySelectorAll("link[rel*='icon']").forEach((el) => el.remove());
  const v = version ? `?v=${encodeURIComponent(version)}` : '';
  ICONS.forEach((i) => {
    const link = document.createElement('link');
    link.rel = i.rel;
    link.type = i.type;
    if (i.sizes) link.sizes = i.sizes;
    link.href = `${API}/api/shop/app-icon-${i.size}.png${v}`;
    document.head.appendChild(link);
  });
  const man = document.querySelector("link[rel='manifest']");
  if (man) man.href = `${API}/api/shop/manifest.webmanifest${v}`;
}

export default function BrandFavicon() {
  useEffect(() => {
    applyIcons('');
    axios.get(`${API}/api/shop/brand`)
      .then((r) => applyIcons(r.data?.updated_at || r.data?.app_name || ''))
      .catch(() => {});
  }, []);
  return null;
}
